import React from 'react';
import { Card, Sym } from '../../../components/app2';

/**
 * Panel lateral del portal del empleado (rediseño jul-2026):
 * "Resumen de nómina" (rejilla de métricas) + "Actividad reciente".
 */

const formatCurrency = (amount) =>
  new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
  }).format(amount || 0);

const PayrollSummaryPanel = ({ summaryData }) => {
  const metrics = [
    { label: 'Ingresos del mes', value: formatCurrency(summaryData?.currentMonthEarnings), color: 'var(--heading)' },
    { label: 'Ingresos del año', value: formatCurrency(summaryData?.yearToDateEarnings), color: 'var(--ok)' },
    { label: 'Recibos pendientes', value: String(summaryData?.pendingReceipts ?? 0), color: 'var(--warn)' },
  ];

  const activity = summaryData?.recentActivity || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Card pad={false} style={{ padding: 20 }}>
        <h3 className="a2-card-title" style={{ fontSize: '1.1rem', marginBottom: 16 }}>
          Resumen de nómina
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          {metrics.map((m) => (
            <div key={m.label}>
              <div style={{ font: "500 .78rem 'Hanken Grotesk'", color: 'var(--muted)', marginBottom: 3 }}>
                {m.label}
              </div>
              <div className="a2-serif" style={{ fontSize: '1.15rem', fontWeight: 600, color: m.color }}>
                {m.value}
              </div>
            </div>
          ))}
        </div>
      </Card>

      <Card pad={false} style={{ padding: 20 }}>
        <h3 className="a2-card-title" style={{ fontSize: '1.1rem', marginBottom: 14 }}>
          Actividad reciente
        </h3>
        {activity.length === 0 ? (
          <p style={{ font: "500 .84rem 'Hanken Grotesk'", color: 'var(--muted)', margin: 0 }}>
            Aún no hay actividad que mostrar.
          </p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {activity.map((a, i) => (
              <div key={`${a?.description}-${i}`} style={{ display: 'flex', gap: 11, alignItems: 'center' }}>
                <span
                  style={{
                    width: 32, height: 32, borderRadius: 9, background: 'var(--surface-2)',
                    border: '1px solid var(--line-2)', color: 'var(--brand-2)',
                    display: 'grid', placeItems: 'center', flexShrink: 0,
                  }}
                >
                  <Sym name="receipt_long" size={17} />
                </span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className="a2-truncate" style={{ font: "600 .86rem 'Hanken Grotesk'", color: 'var(--heading)' }}>
                    {a?.description}
                  </div>
                  <div style={{ font: "500 .74rem 'Hanken Grotesk'", color: 'var(--muted)' }}>
                    {a?.date}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
};

export default PayrollSummaryPanel;
